import React, { createContext, useContext, useEffect, useState } from "react";
import { useCustomer, useRtoReattemptCategory } from "./store";
import ShowEngagement from "./ShowEngagement";
import ProfilePlaceHolder from "../home/ProfilePlaceHolder";
import CardDiv from "modules/common/card-div/CardDiv";
import SoftBadge from "modules/common/SoftBadge";
import { useOrderSearchForTicket } from "modules/CreateTicket/store";
import { get } from "lodash";
import { useBookingData } from "modules/nextcall/store";
export const CustomerProps = createContext({});

function ShowCustomer({
  caseId,
  nextCall,
  arrowHide,
  actionableTabs,
  isCaseManagement,
  showCustomerInFull,
  setShowCustomerInFull,
}) {
  const { fetchRtoReattemptCategory } = useRtoReattemptCategory();
  const { fetchCustomerData, isLoading, isError, errorMessage, customerData , customeStateClear} = useCustomer();
  const { fetchCrmCategories, crmCategories } = useOrderSearchForTicket();
  const [data, setData] = useState([]);
  const [booking, setBooking] = useState();
  const { fetchBookingData} = useBookingData();
  const currentUrl = window.location.href.split("/");

  useEffect(()=>{
    return customeStateClear();
  }, [])

  useEffect(() => {
    const controller = new AbortController();
    if (caseId) {
      fetchCustomerData(caseId);
      fetchRtoReattemptCategory(caseId);
      _.isEmpty(crmCategories) && fetchCrmCategories();
      !currentUrl.includes("next-call") && fetchBookingData(caseId, setData, setBooking);
    }
    return () => {
      controller.abort();
      customeStateClear();
    };
  }, [caseId]);
  

  const caseCustomerData = {
    customerData: customerData,
    customerOrder: get(customerData, "orders", []),
    customerimages: get(customerData, "images", []),
    formResponses: get(customerData, "responses", {}),
    customerInfo: get(customerData, "user", {}),
    customerAssignment: get(customerData, "assignment", {}),
    nextCall: nextCall,
    arrowHide: arrowHide,
    isCaseManagement: isCaseManagement,
    showCustomerInFull: showCustomerInFull,
    setShowCustomerInFull: setShowCustomerInFull,
    customer: customerData,
    actionableTabs: actionableTabs,
    caseId : get(customerData, 'id', null),
    data: data,
    setData: setData,
    booking: booking,
    setBooking: setBooking
  };

  return (
    <div>
      {isLoading && !isError ? (
        <ProfilePlaceHolder />
      ) : !isLoading && !isError ? (
        <CustomerProps.Provider value={caseCustomerData}>
          <ShowEngagement />
        </CustomerProps.Provider>
      ) : (
        <CardDiv
          component={
            <div className="d-flex gap-2 align-items-center">
              <div
                onClick={() => {
                  window.history.back();
                }}
              >
                <SoftBadge className="cursor-pointer" bg="danger">
                  <span className="m-0 fs-3 m-1">Back</span>
                </SoftBadge>
              </div>
              <h2 className="m-0">{errorMessage}</h2>
            </div>
          }
        />
      )}
    </div>
  );
}

export default ShowCustomer;